import useStep1Confirm from '../../../application/bloc/useStep1Confirm';
import { Button, HeadTitle, Popup, Spacer, TextField } from 'oui';
import { FloatingBox, SideBox } from '../../etc/LBox/LBox';

const Step1Confirm = () => {
  const {
    hasTimePassed,
    remainingTime,
    certNumber,
    isButtonDisabled,
    popup,

    changeSecondsToMinutes,
    onClickRequestAgain,
    onClickConfirmButton,
    onChangeCertNumberInput,
  } = useStep1Confirm();

  return (
    <>
      <HeadTitle textTitle={'인증번호 6자리를\n 입력해주세요'} />
      <Spacer size={'lg'} />
      <SideBox>
        <TextField
          onChangeTextInput={onChangeCertNumberInput}
          value={certNumber}
          inputMode={'numeric'}
          placeholder={'인증번호 입력'}
          state={'focused'}
          hasButton={true}
          helperText={changeSecondsToMinutes(remainingTime)}
          buttonText={'인증번호 재요청'}
          onClickButton={onClickRequestAgain}
          warning={hasTimePassed ? '입력시간 초과로 재요청 해주세요.' : ''}
          readOnly={hasTimePassed}
        />
      </SideBox>

      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          onClick={onClickConfirmButton}
          state={isButtonDisabled ? 'disabled' : 'enabled'}
          children={'확인'}
          isDisabled={isButtonDisabled}
        />
      </FloatingBox>

      <Popup
        isPopupOpen={popup.isOpen}
        title={popup.popupMessage}
        confirmBtn={{ text: '네', onClick: popup.onClickConfirm }}
      />
    </>
  );
};

export default Step1Confirm;
